<template>
  <div class="team-activating">
    <ucar-title type="confirmBack">{{title}}</ucar-title>
    <div class="team-activating-success"  v-if="success">
      <img src="../../assets/icon-success.png">
      <h3>账号开通成功</h3>
      <p>您的账号已开通，请前往登录</p>
      <p>登录网址：</p>
      <p>{{url}}</p>
    </div>
    <template v-else>
      <ucar-section>
      <div class="row">
        <label>用户名</label>
        <dynamic-textarea v-model="info.accountName" :maxlength="10" placeholder="请输入"></dynamic-textarea>
      </div>
      <div class="row">
        <label>密码</label>
        <input placeholder="请输入" v-model="info.password" type="password" maxlength="20">
      </div>
      <div class="row">
        <label>确认密码</label>
        <input placeholder="请输入" v-model="info.ensurePassword" type="password" maxlength="20">
      </div>
    </ucar-section>
    <div class="footer">
      <button type="button" class="btn-submit" :class="{'btn-submit-enable': enableSubmit}" @click="submit">
        提交
      </button>
    </div>
    </template>
  </div>
</template>

<script>
import DynamicTextarea from '../../components/dynamic-textarea'
import valid from '../../utils/valid-check'
import ucarStorage from '../../utils/storage'
import { activatingTeam } from '../../api'
import { loginStatus } from '../../utils/constants'

const urlEnum = {
  test: 'http://c2cservicewebtest.10101111.com/',
  test2: 'http://c2cservicewebtest02.10101111.com/',
  test3: 'http://c2cservicewebtest03.10101111.com/',
  pre: 'https://c2cservicewebpre.10101111.com/',
  prod: 'https://c2cserviceweb.10101111.com/'
}

export default {
  data () {
    return {
      title: '神州专车车队招募',
      url: urlEnum[APP_ENV],
      info: {
        accountName: '',
        password: '',
        ensurePassword: ''
      },
      success: ucarStorage.getSession('ucar-login-status') === loginStatus.teamActivated || false
    }
  },
  components: {
    DynamicTextarea
  },
  computed: {
    enableSubmit () {
      const errorInfo =
        valid.notEmpty(this.info.accountName, '用户名不可为空') ||
        valid.notEmpty(this.info.password, '密码不可为空') ||
        valid.notEmpty(this.info.ensurePassword, '确认密码不可为空')
      return errorInfo === ''
    }
  },
  methods: {
    submit () {
      const errorInfo =
        valid.wordOrNum(this.info.accountName, '用户名只能输入字母/数字') ||
        valid.wordOrNum(this.info.password, '密码只能输入字母/数字') ||
        (this.info.password !== this.info.ensurePassword ? '密码与确认密码不一致' : '')
      if (errorInfo) {
        this.$alert(errorInfo)
        return
      }
      activatingTeam({...this.info, recruitId: this.vuexRecruitId})
        .then(res => {
          if (res.status) {
            this.changeStatusToTeamActivated()
            this.success = true
          } else {
            this.$alert('激活失败，请稍后再试')
          }
        })
    }
  },
  mounted () {
    if (this.$route.query.id) this.setVuexRecruitId(this.$route.query.id)
  }
}
</script>

<style lang="stylus">
@import "../../styles/form-base.styl";

.team-activating {
  .team-activating-success {
    display: flex;
    flex-flow: nowrap column;
    align-items: center;
    padding-top: 240px;
    img {
      height: 90px;
      width: 90px;
    }
    h3 {
      margin: 42px 0;
      font-size: $ucar_font_h3;
      color: $ucar_font_color;
    }
    p {
      line-height: 1;
      font-size: $ucar_font_normal;
      margin-bottom 20px;
      color: $ucar_font_assist_color;
      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
}
</style>
